import { Ok } from '../classes/Ok';
import type { Result } from '../types/Result';

/**
 * @group Functions
 * @summary <blockquote>Creates a successful Result (Ok) containing the given value.</blockquote>
 * @typeParam T - The type of the successful value.
 * @typeParam E - The type of the error (defaults to never).
 * @param value - The value to wrap in Ok.
 * @returns An Ok instance.
 * @example
 * ```typescript
 * const result = ok('success');
 * // Returns: Ok('success')
 * ```
 */
export function ok<T, E = never>(value: T): Result<T, E> {
  return new Ok(value);
}
